<template>
    <div>
        <h1>{{ $t("products.heading") }}</h1>
        <router-link :to="{ name: 'createProduct' }" class="btn btn-primary">{{ $t("utils.create") }}</router-link>
        <table class="table">
            <tr>
                <th>{{ $t("products.id") }}</th>
                <th>{{ $t("products.name") }}</th>
                <th>{{ $t("products.category") }}</th>
                <th>{{ $t("products.purchasePrice") }}</th>
                <th>{{ $t("products.defaultPriceIncreaseBy") }}</th>
                <th>{{ $t("products.price") }}</th>
                <th>{{ $t("products.actions") }}</th>
            </tr>
            <tr v-for="(product, i) in products">
                <td>{{ product.product_id }}</td>
                <td>{{ product.name }}</td>
                <td><span v-if="product.category">{{ product.category.name }}</span></td>
                <td>{{ product.purchase_price }} Kč</td>
                <td>{{ product.default_price_increase_by * 100 }} %</td>
                <td>{{ product.purchase_price * (1 + product.default_price_increase_by) }} Kč</td>
                <td>
                    <router-link :to="{ name: 'product', params: {id: product.id} }" class="btn btn-primary me-2">{{ $t("utils.detail") }}</router-link>
                    <button class="btn btn-primary" @click="hide(product.id)">{{ $t("utils.delete") }}</button>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            products: [],
            loading: false
        }
    },
    created: function () {
        this.loadData();
    },
    methods: {
        loadData: function () {
            this.loading = true;
            this.$store.getters.api.get("/products").then(function (response) {
                this.products = response.data.data;
                this.loading = false;
            }.bind(this))
        },
        hide: function (id) {
            this.$store.getters.api.post("/product/" + id +"/hide").then(function (response) {
                this.loadData();
            }.bind(this))
        }
    }
}
</script>
<style lang="scss">
</style>